import { PowerUnit } from '../enums'
import CatalogProduct from './CatalogProduct'
import Company from './Company'
import Device from './Device'

export enum PowerSource {
  DIESEL = 'diesel',
  GASOLINE = 'gasoline',
  GAS = 'gas'
}

export type GeneratorCustomData = {
  isManualRelayControl?: boolean
  additionalLoad?: number
  additionalLoadUnit?: PowerUnit.KILOWATT | PowerUnit.AMPERE
  relayOnThreshold?: number
  relayOffThreshold?: number
}

export type Generator = {
  id: string
  powerSource: PowerSource
  apparentPower: number
  nominalVoltage: number
  nominalCurrent: number | null
  serialNumber: string | null
  customerReference: string | null
  customData: GeneratorCustomData | null
  device?: Device | null
  deviceName?: string | null
  catalogProduct?: CatalogProduct | null
  catalogProductId: string | null
  company?: Company | null
  companyId: number | null
  createdAt: string
  updatedAt: string
}
